import { clamp } from 'lodash-es';
import { forwardRef, useMemo } from 'react';

import { useMergedRef } from '@/hook';

import { TRACK_TYPE, useVBaseTrack } from '../VBaseTrack';
import { joinCn } from '../util';
import style from './style';
import type { VProgressBarProps } from './type';
import { getStepFractionDigit } from './util';

const VInnerProgressBar = <T extends TRACK_TYPE | Lowercase<TRACK_TYPE>>(
  {
    className,
    marked,
    variant,
    ...rest
  }: Pick<VProgressBarProps<T>, 'className' | 'marked' | 'variant'> &
    Omit<React.ComponentPropsWithoutRef<'div'>, 'onChange'>,
  ref: React.Ref<HTMLDivElement>,
) => {
  const {
    disabled,
    max = 100,
    min = 1,
    readOnly,
    step = 1,
    type = TRACK_TYPE.NORMAL,
    value,
    $track: $progressBar,
    setValue,
  } = useVBaseTrack<T>();
  const mergedRef = useMergedRef(ref, $progressBar);
  const stepFractionDigit = useMemo(() => getStepFractionDigit(step), [step]);
  const innerOnChange = (value: VProgressBarProps<T>['value']) => {
    if (readOnly) return;

    if (type === TRACK_TYPE.NORMAL) {
      const newValue = +clamp(value as number, 0, 100).toFixed(
        stepFractionDigit,
      );

      // setValue(newValue as number);
    } else {
      //
    }
  };

  const onClick = (layerX: number, { offsetWidth: oW }: HTMLElement) => {
    const newValue = Math.round(((layerX / oW) * 100) / step) * step;

    // innerOnChange(newValue);
  };

  return (
    <div
      {...rest}
      ref={mergedRef}
      role="progressbar"
      className={joinCn(className, style.vProgressBarContainer, {
        '!cursor-default': readOnly,
      })}
      onClick={e => {
        const bounding = e.currentTarget.getBoundingClientRect();
        const x = bounding.x;
        const layerX = e.clientX - x;

        onClick(layerX, e.currentTarget);
      }}
    >
      <div className={style.vProgressBarBackground}>
        <div
          className={joinCn(style.vProgressBarValue)}
          style={{
            background: variant ?? '',
          }}
        ></div>
      </div>
      <div>{marked ? 'true' : 'false'}</div>
    </div>
  );
};

export default forwardRef(VInnerProgressBar);
